// taken from ENG-3258
import { SubscriptionScopeKey } from "../../Access/helper/subscription/enum/SubscriptionScopeKey";
import { ONE_GB_IN_BYTES } from "./components/FeatureComparison/constants";

export const useDummyDataSubscribeSwitchPlan = false;

// export const SubscriptionScopeDummy = {
//     // Modules
//     [SubscriptionScopeKey.sales]: true,
//     [SubscriptionScopeKey.purchases]: true,
//     [SubscriptionScopeKey.banking]: true,
//     [SubscriptionScopeKey.shoebox]: false,
//     [SubscriptionScopeKey.reports]: false,

// //     // Specific Modules
// //     [SubscriptionScopeKey.batch_sales]: false,
// //     [SubscriptionScopeKey.batch_purchases]: false,
// //     [SubscriptionScopeKey.batch_bank]: false,
// //     [SubscriptionScopeKey.bank_reconciliation]: true,
// //     [SubscriptionScopeKey.journal_entry]: true,
// //     [SubscriptionScopeKey.asset]: true,
// //     [SubscriptionScopeKey.instruction]: true,
// //     [SubscriptionScopeKey.tag]: true,
// //     [SubscriptionScopeKey.manage_custom_field]: false,

//     [SubscriptionScopeKey.inventory_tracking]: false,
//     [SubscriptionScopeKey.email_tracker]: false,
//     [SubscriptionScopeKey.e_invoicing]: false,
//     [SubscriptionScopeKey.invoice_reminder]: false,
//     [SubscriptionScopeKey.payment_gateway]: false,
//     [SubscriptionScopeKey.form_design]: false,
//     [SubscriptionScopeKey.sst]: false,

//     // Multi-based
//     [SubscriptionScopeKey.multi_location]: true,
//     [SubscriptionScopeKey.multi_uom]: true,
//     [SubscriptionScopeKey.multi_currency]: true,
//     [SubscriptionScopeKey.multi_user]: false,
//     [SubscriptionScopeKey.multi_number]: false,
//     [SubscriptionScopeKey.multi_price_level]: true,

// //     // Manage-based
// //     [SubscriptionScopeKey.manage_contact]: true,
// //     [SubscriptionScopeKey.manage_contact_group]: true,
// //     [SubscriptionScopeKey.manage_product]: true,
// //     [SubscriptionScopeKey.manage_product_bundle]: true,
// //     [SubscriptionScopeKey.manage_product_group]: true,
// //     [SubscriptionScopeKey.manage_product_price_level]: true,
// //     [SubscriptionScopeKey.manage_custom_field]: true,

// };

export const SubscriptionQuotaDummy = {
    plan_type: "PREMIUM",
    limit_period_type: "MONTHLY",
    transaction: {
        usage: 55,
        limit: false,
    },
    shoebox: {
        usage: 1,
        limit: 700,
    },
    email: {
        usage: 15,
        limit: 10000,
    },
    storage: {
        usage: 59165119,
        limit: 53687091200,
    },
    whatsapp: {
        usage: 12,
        limit: 200,
    },
    user: {
        usage: 1,
        limit: 2,
    },
};

// NEW FEATURES
export const SubscriptionScopeDummyCurrent = {
    [SubscriptionScopeKey.DASHBOARD]: false,
    [SubscriptionScopeKey.REPORT]: false,

    // Sales
    [SubscriptionScopeKey.SALE]: true,
    [SubscriptionScopeKey["SALE.PAYMENT_GATEWAY"]]: true,
    [SubscriptionScopeKey["SALE.LATE_INTEREST"]]: true,
    [SubscriptionScopeKey["SALE.INVOICE_REMINDER"]]: true,

    // Purchases
    [SubscriptionScopeKey.PURCHASE]: true,

    // Banking
    // [SubscriptionScopeKey.BANK_INCOME_EXPENSE]: true,
    [SubscriptionScopeKey["BANK.TRANSACTION"]]: true,
    [SubscriptionScopeKey["BANK.RECONCILIATION.MANUAL"]]: true,
    [SubscriptionScopeKey["BANK.RECONCILIATION.AUTO"]]: true,

    // All Transactions
    [SubscriptionScopeKey["TRANSACTION.BULK_CREATE"]]: true,
    [SubscriptionScopeKey["TRANSACTION.SHOEBOX"]]: true,
    [SubscriptionScopeKey["TRANSACTION.QUICKSHARE"]]: true, // previously 'TRANSACTION.E_INVOICE'
    [SubscriptionScopeKey["TRANSACTION.INSTRUCTION"]]: true,
    [SubscriptionScopeKey["TRANSACTION.INSTRUCTION.CONTACT_GROUP"]]: true,

    // Contacts
    [SubscriptionScopeKey.CONTACT]: true,
    [SubscriptionScopeKey["CONTACT.BULK_IMPORT"]]: true,
    [SubscriptionScopeKey["CONTACT.GROUP"]]: true,
    [SubscriptionScopeKey["CONTACT.STATEMENT"]]: true,
    [SubscriptionScopeKey["CONTACT.STATEMENT.E_STATEMENT"]]: true,
    [SubscriptionScopeKey["CONTACT.STATEMENT.E_STATEMENT.AUTO"]]: true,

    // Products & Services
    [SubscriptionScopeKey.PRODUCT]: true,
    [SubscriptionScopeKey["PRODUCT.BULK_IMPORT"]]: true,
    [SubscriptionScopeKey["PRODUCT.BUNDLE"]]: true,
    [SubscriptionScopeKey["PRODUCT.GROUP"]]: true,
    [SubscriptionScopeKey["PRODUCT.MULTI_UOM"]]: true,
    [SubscriptionScopeKey["PRODUCT.CUSTOM_PRICE"]]: true,

    // Inventory Tracking
    // [SubscriptionScopeKey.STOCK]: true,
    [SubscriptionScopeKey["INVENTORY.MULTI_LOCATION"]]: true,
    [SubscriptionScopeKey["INVENTORY.STOCK_ADJUSTMENT"]]: true,
    [SubscriptionScopeKey["INVENTORY.STOCK_TRANSFER"]]: true,

    // Accounting & Tax
    [SubscriptionScopeKey["ACCOUNTING.JOURNAL_ENTRY"]]: true,
    [SubscriptionScopeKey["ACCOUNTING.CONTRA"]]: true,
    // [SubscriptionScopeKey.accounting]: true,
    // [SubscriptionScopeKey.ACCOUNTING_ACCOUNT_IMPORT]: true,
    [SubscriptionScopeKey["ACCOUNTING.FIXED_ASSET"]]: true,
    [SubscriptionScopeKey["TAX.SST"]]: true,

    // Other Features
    [SubscriptionScopeKey.MULTI_NUMBER_FORMAT]: true,
    [SubscriptionScopeKey.MULTI_FORM_DESIGN]: true,
    [SubscriptionScopeKey.MULTI_CURRENCY]: true,
    [SubscriptionScopeKey.CUSTOM_FIELD]: true,
    [SubscriptionScopeKey.PRICE_LEVEL]: true,
    [SubscriptionScopeKey.TAG]: true,
    [SubscriptionScopeKey.USER_PERMISSION]: true,
    [SubscriptionScopeKey["USER_PERMISSION.ADVANCED"]]: true,
    [SubscriptionScopeKey.STORE]: true,
    [SubscriptionScopeKey.LIVE_CHAT]: true,

    // Integrations
    [SubscriptionScopeKey["INTEGRATION.PAYROLL"]]: true,
    [SubscriptionScopeKey["INTEGRATION.OPEN_API"]]: true,

};

export const SubscriptionScopeDummyNew = {
    [SubscriptionScopeKey.DASHBOARD]: false,
    [SubscriptionScopeKey.REPORT]: false,

    // Sales
    [SubscriptionScopeKey.SALE]: true,
    [SubscriptionScopeKey["SALE.PAYMENT_GATEWAY"]]: true,
    [SubscriptionScopeKey["SALE.LATE_INTEREST"]]: true,
    [SubscriptionScopeKey["SALE.INVOICE_REMINDER"]]: true,

    // Purchases
    [SubscriptionScopeKey.PURCHASE]: true,

    // Banking
    // [SubscriptionScopeKey.BANK_INCOME_EXPENSE]: true,
    [SubscriptionScopeKey["BANK.TRANSACTION"]]: true,
    [SubscriptionScopeKey["BANK.RECONCILIATION.MANUAL"]]: true,
    [SubscriptionScopeKey["BANK.RECONCILIATION.AUTO"]]: true,

    // All Transactions
    [SubscriptionScopeKey["TRANSACTION.BULK_CREATE"]]: true,
    [SubscriptionScopeKey["TRANSACTION.SHOEBOX"]]: true,
    [SubscriptionScopeKey["TRANSACTION.QUICKSHARE"]]: true, // previously 'TRANSACTION.E_INVOICE'
    [SubscriptionScopeKey["TRANSACTION.INSTRUCTION"]]: true,
    [SubscriptionScopeKey["TRANSACTION.INSTRUCTION.CONTACT_GROUP"]]: true,

    // Contacts
    [SubscriptionScopeKey.CONTACT]: false,
    [SubscriptionScopeKey["CONTACT.BULK_IMPORT"]]: true,
    [SubscriptionScopeKey["CONTACT.GROUP"]]: true,
    [SubscriptionScopeKey["CONTACT.STATEMENT"]]: true,
    [SubscriptionScopeKey["CONTACT.STATEMENT.E_STATEMENT"]]: true,
    [SubscriptionScopeKey["CONTACT.STATEMENT.E_STATEMENT.AUTO"]]: true,

    // Products & Services
    [SubscriptionScopeKey.PRODUCT]: true,
    [SubscriptionScopeKey["PRODUCT.BULK_IMPORT"]]: true,
    [SubscriptionScopeKey["PRODUCT.BUNDLE"]]: true,
    [SubscriptionScopeKey["PRODUCT.GROUP"]]: true,
    [SubscriptionScopeKey["PRODUCT.MULTI_UOM"]]: true,
    [SubscriptionScopeKey["PRODUCT.CUSTOM_PRICE"]]: true,

    // Inventory Tracking
    // [SubscriptionScopeKey.STOCK]: true,
    [SubscriptionScopeKey["INVENTORY.MULTI_LOCATION"]]: true,
    [SubscriptionScopeKey["INVENTORY.STOCK_ADJUSTMENT"]]: true,
    [SubscriptionScopeKey["INVENTORY.STOCK_TRANSFER"]]: true,

    // Accounting & Tax
    [SubscriptionScopeKey["ACCOUNTING.JOURNAL_ENTRY"]]: true,
    [SubscriptionScopeKey["ACCOUNTING.CONTRA"]]: true,
    // [SubscriptionScopeKey.accounting]: true,
    // [SubscriptionScopeKey.ACCOUNTING_ACCOUNT_IMPORT]: true,
    [SubscriptionScopeKey["ACCOUNTING.FIXED_ASSET"]]: true,
    [SubscriptionScopeKey["TAX.SST"]]: true,

    // Other Features
    [SubscriptionScopeKey.MULTI_NUMBER_FORMAT]: false,
    [SubscriptionScopeKey.MULTI_FORM_DESIGN]: false,
    [SubscriptionScopeKey.MULTI_CURRENCY]: false,
    [SubscriptionScopeKey.CUSTOM_FIELD]: false,
    [SubscriptionScopeKey.PRICE_LEVEL]: false,
    [SubscriptionScopeKey.TAG]: false,
    [SubscriptionScopeKey.USER_PERMISSION]: true,
    [SubscriptionScopeKey["USER_PERMISSION.ADVANCED"]]: true,
    [SubscriptionScopeKey.STORE]: true,
    [SubscriptionScopeKey.LIVE_CHAT]: true,

    // Integrations
    [SubscriptionScopeKey["INTEGRATION.PAYROLL"]]: true,
    [SubscriptionScopeKey["INTEGRATION.OPEN_API"]]: true,

};

export const QuotaDummyCurrent = [
    {
        type: 'USER',
        allocation: null, // or false for unlimited, basically the limit
        period_type: null,
    },
    {
        type: 'EMAIL',
        allocation: 1000,
        period_type: 'MONTHLY',
    },
    {
        type: 'STORAGE',
        allocation: 5368709120,
        period_type: null,
    },
    {
        type: 'WHATSAPP',
        allocation: 100000000000,
        period_type: 'MONTHLY',
    },
    {
        type: 'DATA_EXTRACTION',
        allocation: 100,
        period_type: 'YEARLY',
    },
    {
        type: 'TRANSACTION',
        allocation: null,
        period_type: null,
    },
    {
        type: 'FLOW',
        allocation: 100,
        period_type: 'MONTHLY',
    },
];

export const QuotaDummyNew = [
    {
        type: 'USER',
        allocation: 2,
        period_type: null,
    },
    {
        type: 'EMAIL',
        allocation: 100,
        period_type: 'MONTHLY',
    },
    {
        type: 'STORAGE',
        allocation: 104857600,
        period_type: null,
    },
    {
        type: 'WHATSAPP',
        allocation: 50,
        period_type: 'YEARLY',
    },
    {
        type: 'DATA_EXTRACTION',
        allocation: 0,
        period_type: 'MONTHLY',
    },
    {
        type: 'TRANSACTION',
        allocation: 60,
        period_type: 'YEARLY',
    },
];

export const QuotaDummyPremium = [
    {
        type: 'USER',
        allocation: false,
        period_type: null,
    },
    {
        type: 'EMAIL',
        allocation: 10000,
        period_type: 'MONTH',
    },
    {
        type: 'STORAGE',
        allocation: 20 * ONE_GB_IN_BYTES,
        period_type: null,
    },
    {
        type: 'WHATSAPP',
        allocation: 200,
        period_type: 'MONTH',
    },
    {
        type: 'DATA_EXTRACTION',
        allocation: 1000,
        period_type: 'MONTH',
    },
    {
        type: 'TRANSACTION',
        allocation: false,
        period_type: 'MONTH',
    },
    {
        type: 'FLOW',
        allocation: 2000,
        period_type: 'MONTH',
    },
];

export const QuotaDummyGrowth = [
    {
        type: 'USER',
        allocation: 2,
        period_type: null,
    },
    {
        type: 'EMAIL',
        allocation: 1000,
        period_type: 'MONTH',
    },
    {
        type: 'STORAGE',
        allocation: 5 * ONE_GB_IN_BYTES,
        period_type: null,
    },
    {
        type: 'WHATSAPP',
        allocation: 100,
        period_type: 'MONTH',
    },
    {
        type: 'DATA_EXTRACTION',
        allocation: 100,
        period_type: 'MONTH',
    },
    {
        type: 'TRANSACTION',
        allocation: false,
        period_type: 'MONTH',
    },
    {
        type: 'FLOW',
        allocation: 500,
        period_type: 'MONTH',
    },
];
